import { Icon } from '@mc/design-system'

const Ratings = () => (
  <>
    <Icon kind='star-full' />
    <Icon kind='star-full' />
    <Icon kind='star-full' />
    <Icon kind='star-full' />
    <Icon kind='star-half' />
  </>
)

export default Ratings
